type SliderDirection = "previous" | "next";

export const scrollSliderToNeighbor = ({
  scroller,
  direction,
  isRtl,
}: {
  scroller: HTMLDivElement | null;
  direction: SliderDirection;
  isRtl: boolean;
}) => {
  if (!scroller) return;

  const cards = Array.from(scroller.querySelectorAll<HTMLElement>("article"));
  if (!cards.length) return;

  const scrollLeft = scroller.scrollLeft;

  let target: HTMLElement | null = null;

  if (direction === "next") {
    target =
      cards.find((card) =>
        isRtl
          ? card.offsetLeft < scrollLeft - 5
          : card.offsetLeft > scrollLeft + 5
      ) || cards[cards.length - 1];
  } else {
    target =
      [...cards].reverse().find((card) =>
        isRtl
          ? card.offsetLeft > scrollLeft + 5
          : card.offsetLeft < scrollLeft - 5
      ) || cards[0];
  }

  if (!target) return;

  scroller.scrollTo({
    left: target.offsetLeft,
    behavior: "smooth",
  });
};